import { CategoryOverviewRow, Module } from 'src/domain';
import { useCurrentGenderProductlineKey } from './useCurrentGenderProductlineKey';
import { useUnsavedChangesModule } from './useUnsavedChangesModule';

// TODO deleteand replace when Markup has been reworked
export const useUnsavedChangesMarkup = () => {
    const [unsavedChanges] = useUnsavedChangesModule<Record<string, CategoryOverviewRow[]>>(Module.Markup);
    const genderProductlineKey = useCurrentGenderProductlineKey();

    return unsavedChanges?.[genderProductlineKey];
};
